import * as React from "react";
import { useState } from "react";
import { PracticeDetails } from "./Practice";
import TelInput from "../commons/components/form/input/TelInput";
import TextInput from "../commons/components/form/input/TextInput";
import AddressField from "../commons/components/form/input/AddressField";
import { required } from "../commons/model/form/Validators";
import Form from "../commons/components/form/Form";
import HeaderWithToggle from "../settings/HeaderWithToggle";
import { getPayload } from "../commons/utils/form-utils";
import sfetch from "../commons/utils/super-fetch";
import "./PracticeDetailsEditableForm.scss";
import Country from "../commons/model/address/Country";

interface PracticeDetailsEditableViewerProps {
  practiceDetails: PracticeDetails;
  apiUrl: string;
  countries: Country[];
  googleApiKey: string;
}

export default function PracticeDetailsEditableForm({
  countries,
  apiUrl,
  googleApiKey,
  practiceDetails,
}: PracticeDetailsEditableViewerProps) {
  const [selectedCountry, setSelectedCountry] = useState<Country>(practiceDetails.address.country);
  const [hasChanges, setHasChanges] = useState<boolean>();
  const [resetKey, setResetKey] = useState<number>(0);

  return (
    <div className="settings-customisation">
      <Form
        submitLabel={i18n["Global.Save"]}
        submit={async (form) => {
          const payload = getPayload(form, ["name", "phoneNumber"]);
          let address;
          if (form.place) {
            address = { ...form.place.value };
            address.country = address.country.name;
            address.additionalInfo = form.additionalInfo.value;
          } else {
            address = getPayload(form, [
              "number",
              "route",
              "city",
              "zipCode",
              "state",
              "country",
              "additionalInfo",
            ]);
          }
          payload["address"] = address;
          const body = JSON.stringify(payload);
          await sfetch(apiUrl, {
            headers: { "Content-Type": "application/json" },
            method: "PUT",
            body,
          }).then((result) => {
            if (result.ok) {
              history.back();
            }
          });
          document.location.reload();
        }}
        secondaryActionLabel={i18n["Global.Cancel"]}
        secondaryAction={async () => {
          setResetKey((value) => value + 1);
          setHasChanges(false);
        }}
        secondaryActionDisabled={!hasChanges}
        secondaryActionClassName="cancel"
        className="cancellable-form"
        onUpdate={(input, form) => {
          if (!input.status.pristine) setHasChanges(true);
        }}
      >
        <HeaderWithToggle title={i18n["Page.PracticeManagement.Practice.Details"]} />
        <React.Fragment key={resetKey}>
          <TextInput
            name="name"
            label={i18n["Page.PracticeManagement.Practice.Name"]}
            validators={[required()]}
            initialValue={practiceDetails.name}
          />
          <hr />
          <AddressField
            googleApiKey={googleApiKey}
            initialValue={practiceDetails.address}
            countries={countries}
            onCountryChange={setSelectedCountry}
          />
          <TelInput
            name="phoneNumber"
            label={i18n["Page.PracticeManagement.Practice.PhoneNumber"]}
            validators={[required()]}
            initialValue={practiceDetails.phoneNumber}
            availableCountries={countries}
            selectedCountry={selectedCountry}
          />
        </React.Fragment>
      </Form>
    </div>
  );
}
